<template>
    <div class="flex">
      <div class="flexLeft">
        <div style="height: 100%">
          <!-- <img style="height: 96%;" src="../../assets/img/usp/loginLeft.png" /> -->
        </div>
      </div>
      <div class="flexRight">
      </div>
      <div class="loginDiv">
        <div v-if="!isSuccess" style="padding: 80px;">
           <el-form
            ref="registerFormRef"
            class="content"
            :model="form"
            label-width="80px"
            label-position="left"
          >
            <div style="text-align: center;paddingTop: 20px; paddingBottom: 55px">
              <img align="middle" style="width: 174px; height: 50px" src="../../assets/img/usp/logo.png" />
            </div>
            <div class="title">忘记密码</div>
            <div class="directions">填写相关信息，找回密码</div>
            <el-steps class="steps" :active= stepActive align-center finish-status="success">
                <el-step title="填写邮箱名"></el-step>
                <el-step title="设置密码"></el-step>
            </el-steps>
            <div class="carousel">
                <el-carousel ref="carousel" height="320px" :autoplay="false" indicator-position="none" arrow="never" :loop="false">
                    <el-carousel-item :key="1" class="carouselItem">
                        <el-form ref="emailForm" :model="emailForm" status-icon :rules="rules" label-width="100px" :label-position="right" class="emailForm">
                          <el-form-item label="注册邮箱" prop="email">
                            <el-input v-model.trim="emailForm.email" type="text" autocomplete="off" placeholder="请输入注册邮箱" @input="emailChangeFun">
                            </el-input>
                          </el-form-item>
                          <el-form-item label="输入验证码" prop="checkPass">
                            <el-input v-model="emailForm.verCode" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" placeholder="请输入验证码">
                              <el-button slot="append" style="height: 56px;border: none;padding: 0;width: 158px;">
                                <CountDown v-show="showCount" :url-type="8" :is-phone="false" :email="emailForm.email" :form="emailForm" :countdown-style="countdownStyle" :disabled="countdownDisabled" @handleClick="clickBtn"/>
                              </el-button>
                            </el-input>
                          </el-form-item>
                        </el-form>
                        <el-button class="secondStepButton" :disabled="!canSubmit" @click="secondStepClick()">下一步</el-button>
                    </el-carousel-item>
                    <el-carousel-item :key="2" class="carouselItem">
                      <el-form ref="emailPassWordForm" :model="emailPassWordForm" status-icon :rules="passWordRules" label-width="100px" :label-position="right" class="emailForm">
                        <el-form-item label="登录密码" prop="firstEmailPassword">
                          <el-input v-model.trim="emailPassWordForm.firstEmailPassword" type="password" autocomplete="off" placeholder="请输入登录密码" @change="firstEmailPasswordChange()"></el-input>
                        </el-form-item>
                        <el-form-item label="重复登录密码" prop="secondEmailPassword">
                          <el-input v-model.trim="emailPassWordForm.secondEmailPassword" type="password" autocomplete="off" placeholder="请输入登录密码"></el-input>
                        </el-form-item>
                      </el-form>
                        <el-button class="registerButton" @click="registerClick('emailPassWordForm')">修改</el-button>
                    </el-carousel-item>
                </el-carousel>
            </div>
          </el-form>
        </div>
        <div v-else  style="padding: 80px;">
          <div style="text-align: center;paddingTop: 20px;">
            <img align="middle" style="width: 174px; height: 50px" src="../../assets/img/usp/logo.png" />
          </div>
          <div style="text-align: center;paddingTop: 42px">
            <img align="middle" style="width: 180px; height: 180px" src="../../assets/img/usp/loginWasSuccessful.png" />
          </div>
          <div class="welcomeTittle">
            修改成功
          </div>
          <div class="welcomeMessage">
            欢迎回到UAES开发者系统，赶快登录，建立你的场景吧～
          </div>
           <div style="width: 100%;text-align: center;padding-top:200px">
              <el-button class="firstStepButton" @click="signInNow()">立即登录</el-button>
            </div>
        </div>
      </div>
    </div>
  </template>

<script>
import { remoteLoad } from '@/scripts/captcha'
import CountDown from '@/components/CountDown.vue'
import { emailResetSubmit, emailResetSetPassword } from '@/api/modules/forgotPassword'
import { getPasswordRSAV } from '@/scripts/utils'
export default {
  name: 'ForgotPassword',
  components: {
    CountDown
  },
  data() {
    var validatePass = (rule, value, callback) => {
      const res = /^(?=.*[a-zA-Z])(?=.*\d).{6,12}$/
      if (value === '') {
        callback(new Error('请输入密码'))
      }
      else {
        if (this.emailPassWordForm.secondEmailPassword !== '') {
          this.$refs.emailPassWordForm.validateField('secondEmailPassword')
        }
        if (!res.test(value)) {
          callback(new Error(' 至少包含字母、数字，6-12位'))
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      else if (value !== this.emailPassWordForm.firstEmailPassword) {
        callback(new Error('两次输入密码不一致!'))
      }
      else {
        callback()
      }
    }
    return {
      stepActive: '1',
      inited: false,
      activeIndex: '1',
      getCodeClass: 'normalButton',
      radio: '1',
      emailForm: {
        email: '',
        verCode: ''
      },
      emailPassWordForm: {
        firstEmailPassword: '',
        secondEmailPassword: ''
      },
      canSubmit: false,
      countdownStyle: {
        background: '#DDDDDD',
        color: '#FFFFFF',
        height: '56px',
        borderBottomLeftRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        width: '100%'
      },
      showCount: true,
      passWordRules: {
        firstEmailPassword: [
          { validator: validatePass, trigger: 'blur', required: true }
        ],
        secondEmailPassword: [
          { validator: validatePass2, trigger: 'blur', required: true }
        ]
      },
      isSuccess: false,
      countdownDisabled: false
    }
  },
  computed: {
  },
  watch: {
    async $route(_to, _from) {
      if (!this.inited) {
        await this.init()
      }
    }
  },
  async created() {
    await this.init()
  },
  methods: {
    signInNow() {
      this.$router.replace('/login')
    },
    firstEmailPasswordChange(e) {
      console.log(e)
    },
    clickBtn(status) {
      this.canSubmit = status
    },
    handleSelect(e) {
      this.activeIndex = e.name
      console.log(e.name)
    },
    emailChangeFun(value) {
      if (value.endsWith('uaes.com')) {
        this.countdownDisabled = true
        // this.$message({
        //   message: '联合汽车电子员工不允许修改密码',
        //   type: 'warning',
        //   offset: 80
        // })
        this.$confirm(`联合汽车电子员工不允许修改密码`, '确认信息', {
          confirmButtonText: '确认',
          type: 'warning',
          center: true,
          showCancelButton: false,
          confirmButtonClass: 'passwordConfirmButtonClass',
          closeOnClickModal: false
        })
          .then(() => {
            this.emailForm.email = ''
          })
          .catch(action => {
            this.emailForm.email = ''
          })
        return
      }
      else {
        this.countdownDisabled = false
      }
      if (value.length > 0) {
        this.getCodeClass = 'usableButton'
      }
      else {
        this.getCodeClass = 'normalButton'
      }
    },
    async secondStepClick() {
      const res = await emailResetSubmit({ email: this.emailForm.email, code: this.emailForm.verCode })
      if (res.code === 0) {
        this.stepActive = '2'
        this.$refs.carousel.next()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async registerClick(formName) {
      var res1 = /^(?=.*[a-zA-Z])(?=.*\d).{6,12}$/
      if (this.emailPassWordForm.firstEmailPassword === '') {
        return false
      }
      else {
        if (this.emailPassWordForm.firstEmailPassword !== '') {
          this.$refs.emailPassWordForm.validateField('secondEmailPassword')
        }
        if (!res1.test(this.emailPassWordForm.firstEmailPassword)) {
          return false
        }
      }
      if (this.emailPassWordForm.secondEmailPassword === '') {
        return false
      }
      else if (this.emailPassWordForm.secondEmailPassword !== this.emailPassWordForm.firstEmailPassword) {
        return false
      }
      const res = await emailResetSetPassword({
        email: this.emailForm.email,
        password: getPasswordRSAV(this.emailPassWordForm.firstEmailPassword)
      })
      console.log(res)
      if (res.code === 0) {
        this.$refs[formName].resetFields()
        this.isSuccess = true
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    async init() {
      setTimeout(() => {
        remoteLoad('https://turing.captcha.qcloud.com/TCaptcha.js')
      }, 10)
      this.inited = true
    }
  }
}
</script>

<style lang="less" scoped>
  body{
    width:100%;
    height:100%;
  }
    ::-webkit-scrollbar{
      display:none;
    }
    .flex{
      display: flex
    }
    .flexLeft{
      width: calc(100vw * 0.71);
      height: 100vh;
      position: relative;
    }
    .flexRight{
      background-color: #4d78ff;
      width: calc(100vw * 0.29);
      height: 100vh;
    }
    .loginDiv{
      position: absolute;
      left: calc(100vw * 0.5 - 600px);
      align-self: center;
      background: #FFFFFF;
      box-shadow: 0px 17px 28px 4px rgba(0,127,243,0.09);
      border-radius: 4px;
      min-height: 832px;
      min-width: 1200px;
    }
    .title{
        text-align: center;
        font-size: 24px;
        color: #4d78ff;
        font-family:"微软雅黑";
        font-weight: 400;
    }
    .directions{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 25px;
    }
    .steps{
        margin-top: 32px;
    }
    ::v-deep .el-step__head.is-success {
        color: #4d78ff;
        border-color: #4d78ff;
    }
    ::v-deep .el-step__title.is-success {
        font-weight: bold;
        color: #4d78ff;
    }
    ::v-deep .el-step__description.is-success {
        color: #4d78ff;
    }
    ::v-deep .el-step__head.is-success .el-step__icon{
      color: #ffffff;
      background: #4d78ff;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
  }
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
  .carouselItem{
    width: 500px;
    padding-left: 250px;
    text-align: center;
  }
  .carousel{
    margin-top: 60px;
  }
  .firstStepButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .secondStepButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .registerButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .appendText{
    font-size: 14px;
    font-weight: 400;
    color: #2F374B;
  }
  .normalButton{
    background: #DBDBDB !important;
    border: 1px solid #DBDBDB !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .usableButton{
    background: #003A6F !important;
    border: 1px solid #003A6F !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .radioList{
    height: 210px;
  }
  .radioListView{
    height: 210px;
  }
  .radioTitle{
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    color: #838383;
  }
  .radioListCellView{
    margin-top: 20px;
    height: 190px;
    overflow-y: auto;
  }
  .radioCell{
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #838383;
  }
  ::v-deep .el-input__inner {
    height:56px
  }
  ::v-deep .el-form-item__label{
    width: 120px !important;
  }
  ::v-deep .el-form-item__content{
    margin-left: 120px !important;
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #4d78ff !important;
    background: #4d78ff !important;
  }
  ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #4d78ff !important;
  }
  .el-icon-share {
    background: url('../../assets/img/usp/enterprise.png') center center no-repeat;
    background-size: 24px;
  }
  .el-icon-share:before {
    content: "11";
    visibility: hidden;
  }
  .el-icon-s-data {
    background: url('../../assets/img/usp/college.png') center center no-repeat;
    background-size: 24px;
  }
  .el-icon-s-data:before {
    content: "11";
    visibility: hidden;
  }
  .countdown .getNumber{
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF !important;
      background: #4d78ff !important;
  }
  ::v-deep .el-step__icon{
    width: 38px;
    height: 38px;
  }
  ::v-deep .el-step.is-horizontal .el-step__line{
    top: 17px;
  }
  .welcomeTittle{
    height: 24px;
    font-size: 24px;
    font-weight: 400;
    color: #2F374B;
    text-align: center;
    padding-top: 20px;
  }
  .welcomeMessage{
    height: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 25px;
    text-align: center;
    padding-top: 20px;
  }
::v-deep .el-form-item--feedback .el-input__validateIcon {
  display: none !important;
}

</style>
